import $axios from "@/axios-instance";
import { ref, onMounted } from "@vue/composition-api";
import { SnackbarProgrammatic as Snackbar } from "buefy";

export default function useProjectFloorplans(
  projectName,
  // {perPage, filters, initialize}
  defaultOptions
) {
  if (!defaultOptions) {
    defaultOptions = {};
  }
  const floorplans = ref([]);
  const fetch = async (page, options) => {
    if (!options) options = {};
    // Override default if parameters are given.
    const perPage = options.perPage
      ? options.perPage
      : defaultOptions.defaultPerPage;
    if (!perPage) {
      throw new Error("perPage not given");
    }
    let filters = options.filters
      ? options.filters
      : defaultOptions.defaultFilters;
    //     Set empty object for filters if its null.
    if (!filters) {
      filters = {};
    }
    // Throw if no project is selected
    if (!projectName) {
      throw new Error("Project not selected.");
    }
    // Setup query parameters
    //     Setup pagination
    const paramsArr = [`page=${page}`, `limit=${perPage}`];
    //     Apply filters
    Object.entries(filters).forEach(([on, val]) => {
      paramsArr.push(`${on}=${val}`);
    });
    //     Join parameters into a query string
    const params = paramsArr.join("&");
    // Call API
    const res = await $axios.get(
      `/projects/${projectName}/floorplans?${params}`
    );
    const data = res.data;
    if (!data || !data.success) {
      throw new Error("Server Access Failed");
    }

    floorplans.value = data.payload.docs;
    return data.payload;
  };

  onMounted(async () => {
    if (defaultOptions && !defaultOptions.initialize) return;
    try {
      await fetch(1);
    } catch (error) {
      Snackbar.open({
        message: error.message,
        actionText: "Close",
        type: "is-warning",
        indefinite: true,
        position: "is-top"
      });
    }
  });

  return {
    floorplans,
    fetch
  };
}
